export enum ModuleEnum {
  ACTIVITY = 'ACTIVITY',
  BANNER = 'BANNER',
  NAV_LAYER = 'NAV_LAYER',
  NAV_PAGE = 'NAV_PAGE',
  NAV_PAGE_PREVIEW = 'NAV_PAGE_PREVIEW',
  NAV_PAGE_EDITOR = 'NAV_PAGE_EDITOR',
  NAV_ALBUM = 'NAV_ALBUM',
  NAV_ALBUM_ITEM = 'NAV_ALBUM_ITEM',
  USER_ACCOUNT = 'USER_ACCOUNT',
  USER_ACCOUNT_TYPE = 'USER_ACCOUNT_TYPE',
  PROFILE_SETTING = 'PROFILE_SETTING',
  DASHBOARD = 'DASHBOARD',
  VENUE = 'VENUE',
  VENUE_BOOKING = 'VENUE_BOOKING',
  VENUE_BOOKING_RECORD = 'VENUE_BOOKING_RECORD',
  BUTTON_URL = 'BUTTON_URL',
  SHORTEN_URL = 'SHORTEN_URL',
  DONATION = 'DONATION',
  VOLUNTEER_GROUP = 'VOLUNTEER_GROUP',
  PAST_COMMITTEE = 'PAST_COMMITTEE',
  DHARMA_HUB = 'DHARMA_HUB',
  VIDEO_PODCAST = 'VIDEO_PODCAST',
  VIDEO_PODCAST_CATEGORY = 'VIDEO_PODCAST_CATEGORY',
  LEARNING = 'LEARNING',
  COMMITTEE_DESCRIPTION = 'COMMITTEE_DESCRIPTION',
  SITE_SETTING = 'SITE_SETTING',
}